// AT-7 (2026-06-09): workflow de status dos atestados (alinhado ao Notion).
// Compartilhado entre AbaAtestados (contrato), ModalAtestado e a página
// global ComercialAtestados (Lista + Kanban).

export interface StatusAtestadoCfg {
  key: string;
  label: string;
  /** cor de Tag do Antd */
  tagColor: string;
  /** cor hex pro header da coluna do kanban */
  hex: string;
}

// Ordem = ordem das colunas do kanban
export const STATUS_ATESTADO: StatusAtestadoCfg[] = [
  { key: 'backlog',          label: 'Backlog',               tagColor: 'default',  hex: '#8c8c8c' },
  { key: 'draft',            label: 'Draft',                 tagColor: 'blue',     hex: '#1677ff' },
  { key: 'formatacao',       label: 'Formatação',            tagColor: 'cyan',     hex: '#13c2c2' },
  { key: 'revisao_final',    label: 'Revisão Final',         tagColor: 'purple',   hex: '#722ed1' },
  { key: 'enviado_cliente',  label: 'Enviado ao cliente',    tagColor: 'orange',   hex: '#fa8c16' },
  { key: 'assinado_cliente', label: 'Assinado pelo cliente', tagColor: 'green',    hex: '#52c41a' },
  { key: 'analise_crea',     label: 'Em análise do CREA',    tagColor: 'geekblue', hex: '#2f54eb' },
  { key: 'correcoes_crea',   label: 'Correções CREA',        tagColor: 'red',      hex: '#f5222d' },
  { key: 'timbrado_cat',     label: '✓ Timbrado com CAT',    tagColor: 'success',  hex: '#389e0d' },
];

export const STATUS_ATESTADO_MAP: Record<string, StatusAtestadoCfg> = Object.fromEntries(
  STATUS_ATESTADO.map(s => [s.key, s])
);

// Cancelado fica fora do kanban mas precisa de tag na lista
export const STATUS_CANCELADO: StatusAtestadoCfg =
  { key: 'cancelado', label: 'Cancelado', tagColor: 'red', hex: '#a8071a' };

export function statusCfg(key: string | null | undefined): StatusAtestadoCfg {
  if (!key) return STATUS_ATESTADO[0];
  if (key === 'cancelado') return STATUS_CANCELADO;
  return STATUS_ATESTADO_MAP[key]
    // status legados que possam ter sobrado em cache local
    || STATUS_ATESTADO_MAP[({
      rascunho: 'draft', em_revisao: 'revisao_final', emitido: 'enviado_cliente',
      aguardando_assinatura: 'enviado_cliente', assinado: 'assinado_cliente',
      cat_solicitada: 'analise_crea', cat_emitida: 'timbrado_cat',
    } as Record<string, string>)[key]]
    || { key, label: key, tagColor: 'default', hex: '#8c8c8c' };
}
